module.exports = __webpack_public_path__ + "img/shichang.29c7f3c7.svg";